"use client";

import { useEffect, type ReactNode } from "react";

import { trackKeyboardSafeHeight } from "@demo/libs/keyboard-safe-height";

export function KeyboardSafeHeightProvider({ children }: { children: ReactNode }) {
  useEffect(() => trackKeyboardSafeHeight(), []);
  return <>{children}</>;
}
